import { render, staticRenderFns } from "./ExternalVenues.vue?vue&type=template&id=25d360f4&scoped=true&"
import script from "./ExternalVenues.vue?vue&type=script&lang=js&"
export * from "./ExternalVenues.vue?vue&type=script&lang=js&"
import style0 from "./ExternalVenues.vue?vue&type=style&index=0&id=25d360f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d360f4",
  null
  
)

export default component.exports